import { Link, useSearchParams } from "react-router-dom";
import { XCircle, ArrowLeft } from "lucide-react";

export default function PaymentCancel() {
  const [params] = useSearchParams();
  const returnTo = params.get("returnTo") || "/patient-dashboard";
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow p-8 text-center" data-testid="payment-cancel">
        <div className="w-16 h-16 rounded-full bg-amber-100 flex items-center justify-center mx-auto mb-4">
          <XCircle className="w-9 h-9 text-amber-600" />
        </div>
        <h1 className="text-2xl font-semibold text-slate-900 mb-2">Payment cancelled</h1>
        <p className="text-slate-600 mb-6">You closed the checkout page before completing payment. No charge was made — you can try again any time from your dashboard.</p>
        <Link
          to={returnTo}
          data-testid="payment-cancel-back"
          className="inline-flex items-center gap-2 bg-purple-600 hover:bg-purple-700 text-white font-semibold px-5 py-2.5 rounded-full transition"
        >
          <ArrowLeft className="w-4 h-4" /> Back to my dashboard
        </Link>
      </div>
    </div>
  );
}
